export default "__VITE_ASSET__a8e2fb3d__"